import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      typeOverride: false,
      locked: false,
      lockStatus: null,
      lockId: true,
      lockComponentId: null,
      onLockUpdate: false,
      lockTimeout: 1800 // Release locks after 30 minutes anyway
    }
  },
  computed: {
    ...mapGetters(['baseDomain', 'shopId', 'clientid', 'apiKey']),
  },
  methods: {
    getComponentItemId () {
      let id
      if (this.component && this.component.initData) {
        let key = Object.keys(this.component.initData).find(key => key === 'id' || key.endsWith('Id'))
        if (key) {
          id = this.component.initData[key]
        }
      }
      return id
    },
    async getComponentLock (force = false, overrideType = false) {
      this.typeOverride = overrideType
      this.onLockUpdate = false
      let id = this.getComponentItemId()
      if (!id) {
        return
      }
      if (!this.component) {
        return
      }
      let componentType = overrideType || this.component.type
      this.lockComponentId = this.getComponentItemId()
      this.EventBus.$off('lockUpdate')
      this.EventBus.$on('lockUpdate', (message) => {
        if (message.data && message.data.type === componentType && message.data.itemid == this.getComponentItemId() && message.data.sid !== this.clientid) {
          this.getComponentLock(false, overrideType)
          this.onLockUpdate = true
        }
      })
      let response
      try {
        // 403 just means someone else holds the lock, not an auth failure.
        response = await axios.get(this.baseDomain + this.shopId + '/locks/' + id + '.json?type=' + componentType + '&sid=' + this.clientid + '&timeout=' + this.lockTimeout + (force ? '&force=true' : '') + '&apikey=' + this.apiKey, { skipAuthRecovery: true })
      } catch(e) {
        this.locked = true
        this.lockId = null
        this.lockStatus = e.response && e.response.data ? e.response.data.errorMessage : null
        if (this.onLockUpdate && typeof this.lockCallback === "function") {
          this.onLockUpdate = false
          this.lockCallback(true)
        } 
        return
      }
      this.lockId = response.data
      this.locked = false
      this.lockStatus = null
      if (this.onLockUpdate && typeof this.lockCallback === "function") {
        this.onLockUpdate = false
        this.lockCallback(false)
      } 
    },
    async releaseComponentLock (overrideId = false, overrideType = false) {
      if (!this.component) {
        return
      }
      if(this.typeOverride && !overrideType) {
        overrideType = this.typeOverride
      }
      const componentType = overrideType || this.component.type
      this.EventBus.$off('lockUpdate')
      let id = overrideId || this.getComponentItemId()
      if (!id || !this.lockId) {
        return
      }
      const data = {
        id: id
      }
      try {
        await axios.delete(this.baseDomain + this.shopId + '/locks/' + id + '.json?type=' + componentType + '&lock_id=' + this.lockId + '&apikey=' + this.apiKey, data)
      } catch(e) {}
      this.locked = null
    },
    releaseComponentLockWrapper () { // The purpose of this is to get rid of the event parameter that addEventListener adds to the method call
      this.releaseComponentLock()
    }
  }
}